<div class="plus-button">
    <app-dropdown
        class="component"
        [ngClass]="{
            'highlight-animated': highlightAnimated,
            'highlight-focused': highlightFocused
        }"
        [items]="items$ | async"
        [formControl]="control"
        [searchable]="true"
        (click)="onHighlightFocus()"
        (focusin)="onHighlightFocus()"
        (focus)="onHighlightFocus()"
    />
    <button (click)="setEditMode()" *ngIf="!disabled" class="text">
        <span class="material-symbols-rounded">add</span>
    </button>
</div>

<ng-container *ngIf="editMode">
    <form [formGroup]="editForm">
        <app-form-section>
            <div class="plus-button">
                <input
                    #nameInput
                    class="component"
                    appInputValidator
                    [checkValidity]="showPotentialValidationMessages"
                    id="name"
                    formControlName="name"
                    type="text"
                />
                <button type="submit" class="primary" (click)="create()" [disabled]="!canStore">
                    {{ 'BUTTONS.OK' | translate }}
                </button>
            </div>
        </app-form-section>
    </form>
</ng-container>
